import { eventDetailsSagaWatcher } from './events';
import { offerSagaWatcher, offerSectionsSagaWatcher } from './offers';
import { all } from 'redux-saga/effects';

export function* rootSaga() {
  yield all([
    offerSagaWatcher(),
    offerSectionsSagaWatcher(),
    eventDetailsSagaWatcher(),
  ]);
}



// WEBPACK FOOTER //
// ./src/common/sagas/index.js